import { render, staticRenderFns } from "./year_bonus.vue?vue&type=template&id=2d78bfd5"
import script from "./year_bonus.vue?vue&type=script&lang=js"
export * from "./year_bonus.vue?vue&type=script&lang=js"
import style0 from "./year_bonus.vue?vue&type=style&index=0&id=2d78bfd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports